import store from "../store";
import { storeGet, storeSet } from "../localStore";
import { PACKET_APP_ID } from "../config";
import { getUser } from "@/apis/packet";
import { sort_ASCII } from "@/libs/utils";

const packetRoute = async (to, from, next) => {
  // 1.先判断store中有无userInfo
  const { userInfo } = store.state.packet;
  if (userInfo.open_id) {
    console.log("用户信息存在", 1, userInfo);
    next();
    return;
  }
  // 2.判断URL中是否存在CODE参数
  if (locationSearchCode()) {
    // 如果存在CODE，则为授权页跳回
    const { code, state } = handleLocationSearch();
    console.log("code获取信息", 2, code, state);
    // 对被微信拼接了code参数的url处理下 处理掉code
    const _url = window.location.origin + window.location.pathname;
    window.history.replaceState({}, 0, _url);
    // 获取微信授权信息
    const r = await getUser({
      code: code,
      sign: sort_ASCII({ code: code })
    });
    store.commit("packet/CHANGE_USERINFO", { userInfo: r.content });
    storeSet("HB_OPEN_ID", r.content.open_id);
    // 未绑定过账号的跳转到账号绑定页面，否则跳转到角色选择页面
    if (r.content.status === 1) {
      next({ name: "role" });
      return;
    }
    next({ name: "login" });
    return;
  }
  // 3.判断本地是否存着open_id
  const hb_open_id = storeGet("HB_OPEN_ID");
  if (hb_open_id) {
    // 如果存在，拿open_id换用户信息并且存store中
    console.log("本地缓存获取信息", 3, hb_open_id);
    let r;
    try {
      // 如果拿openid换取用户信息接口返回错误 则清空缓存 重新加载页面
      r = await getUser({
        open_id: hb_open_id,
        sign: sort_ASCII({ open_id: hb_open_id })
      });
    } catch (error) {
      console.error("open_id error");
      localStorage.clear();
      next({ path: "/packet/" });
      return;
    }
    const userData = {
      ...r.content,
      open_id: hb_open_id
    }
    store.commit("packet/CHANGE_USERINFO", { userInfo: userData });
    // 未绑定过账号的跳转到账号绑定页面，否则跳转到角色选择页面
    if (r.content.status === 1) {
      next({ name: "role" });
      return;
    }
    // next({ path: "/packet/" });
    next({ name: "login" });
    return;
  }
  // 4.无open_id且store中也不存在用户信息，则跳开放平台获取code
  console.log("开放平台", 4);
  const redirect_uri = encodeURIComponent(window.location.href);
  const query = handleQuery(to.query);
  const state = `${to.name}_HB_${query}`;
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${PACKET_APP_ID}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`;
};

// 判断是否为授权页跳回
const locationSearchCode = () => {
  try {
    const search = decodeURIComponent(window.location.search);
    const flag = search.indexOf("code") === -1 ? false : true;
    return flag;
  } catch (error) {
    console.log("授权页", error);
    return false;
  }
};

const handleLocationSearch = () => {
  // ?code=071ooabY1ZDee01tmA9Y1tsUaY1ooabb&state=
  try {
    let search = decodeURIComponent(window.location.search);
    search = search.slice(1);
    let obj = {};
    search = search.split("&state=");
    obj.code = search[0].split("=")[1];
    obj.state = search[1];
    return obj;
  } catch (e) {
    console.log("auth", e);
    return {};
  }
};

const handleQuery = query => {
  let arr = [];
  for (let it in query) {
    arr.push(`${it}=${query[it]}`);
  }
  arr = arr.join("_HB_");
  return arr;
};

export default packetRoute;
